// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppUI from './AppUI';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import theme from './theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ChakraProvider theme={theme}>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <AppUI />
    </ChakraProvider>
);
